/*
 * Public API Surface of ngx-number-spinner
 */
export * from './app/components/ngx-number-spinner/ngx-number-spinner.component';

export * from './app/ngx-number-spinner.module';
